import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {BaseComponent} from 'web/components/BaseComponent';
import enumList from 'web/utils/enumList';
import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  CASE_STATUS_OPEN,
  CASE_STATUS_CLOSE,
} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';
import {Typeahead} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {useSatisFactionSurveyDetail} from '../hooks/useSatisFactionSurveyDetail';
import DataTableLoading from 'web/components/DataTableLoading';

const SatisfactionSurveyDetailPage = (props) => {
  const dispatch = useDispatch();
  const [uploadFiles, setUploadFiles] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);
  const [invalidShow, setInvalidShow] = useState('none');
  const [isLoading, setIsLoading] = useState(false);
  const {
    casePriorityDisplay,
    customerData,
    formValues,
    caseDetailFiles,
    customerSelection,
    conditions,
    conditionList,
    setCaseDetailFiles,
    setCasePriorityDisplay,
    setCustomerSelection,
    setCustomerData,
    setFormValues,
    setConditions,
    getCaseByCaseNumber,
    getCustomerSelection,
    handleEditCase,
    goBack,
  } = useSatisFactionSurveyDetail(dispatch, showMessage);

  const updateFormValues = (updatedValues) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      ...updatedValues,
    }));
  };

  const handleChange = (event) => {
    const {name, value} = event.target;

    updateFormValues({
      [name]: value,
    });
  };

  const handleUploadChange = (event) => {
    const {files} = event.target;
    const file = files[0];
    setUploadFiles([...uploadFiles, file]);
  };
  const handleConditionChange = (event) => {
    const {value} = event.target;

    if (conditions.includes(value)) {
      setConditions(conditions.filter((item) => item !== value));
    } else {
      setConditions([...conditions, value]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }

    form.classList.add('was-validated');

    const formData = new FormData(form);

    const req = {
      casePriority: formData.get('casePriority'),
      caseNumber: formValues.caseNumber,
      customerCode: customerData[0].customerCode,
      description: formData.get('description'),
      handlingProcess: formData.get('handlingProcess'),
      deleteFiles,
      conditions,
    };

    handleEditCase(req, uploadFiles);

    resetForm(form);
  };

  const resetForm = (form) => {
    form.classList.remove('was-validated');
    setUploadFiles([]);
    setDeleteFiles([]);
  };

  // 刪除新上傳的檔案
  const handleDeleteFile = (fileName) => {
    const files = uploadFiles.filter((file) => file.name !== fileName);
    setUploadFiles(files);
  };

  // 刪除已上傳的檔案
  const handleDeleteDetailFile = (fileToDelete) => {
    setCaseDetailFiles((prevFiles) =>
      prevFiles.filter((file) => file.filePath !== fileToDelete.filePath),
    );
    setDeleteFiles((prevFiles) => [...prevFiles, fileToDelete.fileName]);
  };

  const checkIsOpen = () => {
    return formValues.flgStatus === enumList.caseFlgStatus.close;
  };

  const checkPriorityIsHigh = () => {
    return formValues.casePriority === enumList.casePriority.high;
  };

  useEffect(() => {
    setIsLoading(true);
    const baseComponent = new BaseComponent(props);
    baseComponent.checkPermission(
      enumList.moduleEnums.case,
      enumList.accessModeEnums.read,
    );
    getCustomerSelection();
    getCaseByCaseNumber();
    setIsLoading(false);
  }, []);

  return (
    <section id="datatable-container">
      <DataTableLoading {...{isLoading}} />
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="f-fs-sm btn" onClick={goBack}>
            <i className="bi bi-arrow-left me-1"></i>
            回上頁
          </li>
        </ol>
      </nav>
      <form
        className=" needs-validation"
        id="modalResidentForm"
        noValidate
        onSubmit={handleSubmit}
      >
        <div className="modal-body">
          <div className="d-flex flex-column gap-3 px-2">
            <div className="modal__form__catagory row">
              <div className="col-12">
                <div className="d-flex gap-3">
                  <div
                    className={`status ${
                      checkPriorityIsHigh() ? 'status-rush' : ''
                    } mb-2`}
                  >
                    <span>
                      {checkPriorityIsHigh()
                        ? CASE_PRIORITY_HIGH
                        : CASE_PRIORITY_NORMAL}
                    </span>
                  </div>
                  {/* <div className={`status status-${checkIsOpen() ? 'normal' : 'danger'} mb-2`}>
                    <span>{checkIsOpen() ? CASE_STATUS_CLOSE : CASE_STATUS_OPEN}</span>
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-3">
                    <label htmlFor="startTime" className="form-label">
                      處理開始時間
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="startTime"
                      name="startTime"
                      value={formValues.startDate}
                      required
                      disabled
                    />
                  </div>
                  <div className="col-3">
                    <label htmlFor="endTime" className="form-label">
                      處理結束時間
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="endTime"
                      name="endTime"
                      value={formValues.endDate}
                      required
                      disabled
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="caseNumber" className="form-label">
                      立案編號
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="caseNumber"
                      name="caseNumber"
                      value={formValues.caseNumber}
                      required
                      disabled
                    />
                  </div>
                  {/* <div className="col-6">
                    <label htmlFor="customerName" className="form-label">
                      客戶名稱
                    </label>
                    <Typeahead
                      id="customerName"
                      size="sm"
                      onChange={setCustomerData}
                      selected={customerData}
                      value={customerData}
                      options={customerSelection}
                      labelKey="customerName"
                      placeholder="請輸入客戶名稱"
                      disabled
                      required
                    />
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-12 mt-3">
                    <label htmlFor="customerName" className="form-label">
                      客戶名稱
                    </label>
                    <Typeahead
                      id="customerName"
                      size="sm"
                      onChange={setCustomerData}
                      selected={customerData}
                      value={customerData}
                      options={customerSelection}
                      labelKey="customerName"
                      placeholder="請輸入客戶名稱"
                      disabled
                      required
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <label htmlFor="" className="form-label">
                      附件資料
                    </label>
                    <div className="d-flex gap-2 flex-wrap my-2">
                      {(caseDetailFiles.length > 0 &&
                        caseDetailFiles.map((file, index) => (
                          <button
                            type="button"
                            key={index}
                            className="btn btn-outline-secondary rounded-pill"
                            onClick={() => {
                              console.log('click');
                            }}
                          >
                            <svg className="btn__icon me-1" aria-hidden="true">
                              <use href="#ico-file-04"></use>
                            </svg>
                            {file.fileName}
                            {/* <i
                              className="bi bi-x-lg ms-3"
                              onClick={(e) => {
                                e.preventDefault();
                                handleDeleteDetailFile(file);
                              }}
                              style={{ color: 'var(--ce-colors-gray-light-mode--700)' }}
                            ></i> */}
                          </button>
                        ))) || (
                        <div className="text-muted f-fs-sm">無附件資料</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mt-3">
                    <label htmlFor="description" className="form-label">
                      案件內容
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      value={formValues.description}
                      onChange={handleChange}
                      rows="2"
                      disabled
                    ></textarea>
                  </div>
                  <div className="col-12 mt-3">
                    <label htmlFor="handlingProcess" className="form-label">
                      處理經過
                    </label>
                    <textarea
                      className="form-control"
                      id="handlingProcess"
                      name="handlingProcess"
                      value={formValues.handlingProcess}
                      onChange={handleChange}
                      rows="2"
                      disabled
                    ></textarea>
                  </div>
                  <div className="col-12 mt-3">
                    <label
                      htmlFor="modalCSATContentSurvey"
                      className="form-label"
                    >
                      滿意度調查
                    </label>
                    <div>
                      {new Array(5).fill().map((_, i) => (
                        <i
                          key={i}
                          className={
                            'bi bi-star-fill' +
                            (formValues.satisfaction?.satisfactionScore > i
                              ? ' star-checked'
                              : '')
                          }
                        ></i>
                      ))}
                    </div>
                  </div>
                  <div className="col-12">
                    <textarea
                      className="form-control mt-2"
                      id="modalCSATContentSurvey"
                      rows="2"
                      value={formValues.satisfaction?.comment}
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div
                  className="alert alert-warning global-invalid-feedback"
                  style={{display: invalidShow}}
                ></div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="d-flex justify-content-end w-100">
          <button type="button" className="btn btn-cancel" onClick={goBack}>
            取消
          </button>
          <button type="submit" className="btn btn-primary">
            儲存
          </button>
        </div> */}
      </form>
    </section>
  );
};

export default SatisfactionSurveyDetailPage;
